




































import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator'
import VFormBase from 'vuetify-form-base'
import { TournamentAPI } from '@/api/tournament'

interface VForm extends HTMLFormElement {
  validate(): boolean
}

@Component({
  components: {
    VFormBase
  }
})
export default class TournamentCustomForm extends Vue {
  @Prop({ type: Object, required: true }) readonly schema!: any

  @Ref() readonly form!: VForm

  isValid: boolean = false

  value: any = {}

  @Emit('submit')
  submit() {
    return this.value
  }

  // FIXME: temp code

  shouldHide: boolean = false

  async created() {
    try {
      const res = await TournamentAPI.shouldHideForm()
      this.shouldHide = res.data.payload!
    } catch (err) {
      // we don't care
    }
  }

  get theSchema() {
    if (this.shouldHide) {
      const schema = { ...this.schema }
      delete schema['studentidf']
      delete schema['studentidb']

      return schema
    }

    return this.schema
  }

  // end of temp code

  submitForm() {
    if (!this.form.validate()) return

    // Invoke and emit submit form event
    this.submit()
  }

  // Validation Rules

  // Helper & Partial Functions
  minLen = (l: any) => (v: string) =>
    (v && v.length >= l) || `min. ${l} Characters`
  maxLen = (l: any) => (v: string) =>
    (v && v.length <= l) || `max. ${l} Characters`
  required = (msg: string) => (v: string) => !!v || msg
  requiredArray = (msg: string, minLength = 1) => (v: any[]) =>
    (Array.isArray(v) && v.length > minLength) || msg

  // Rules
  rules = {
    requiredEmail: this.required('E-mail is required'),
    requiredSel: this.required('Selection is required'),
    requiredSelMult: this.requiredArray('2 Selections are required'),
    max12: this.maxLen(12),
    min6: this.minLen(6),
    validEmail: (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  }
}
